<template>
  <div>
    <StaffContents
    :profileImg="require('../../assets/img/gen/staff/02/profile.jpg')"
    :profileImgSp="require('../../assets/img/gen/staff/02/profile_sp.jpg')"
    profileAlt="02 LEE Juhee"
    answer01="韓国の女子大学で地理教育を専攻していました。地理踏査サークルを自ら立ち上げ、韓国全域を回りながら地理を勉強。チームごとにひとつの地域を担当し、様々な論文を参考にしながら地域の形成過程や人々への影響を調査したり、実際に踏査地域を訪問して住民の方々にインタビューを実施したりもしました。教科書だけでは学べないことを数多く勉強でき、実際に自分の目で見て学ぶことの大切さを実感しましたね。"
    answer02="交換留学で日本に滞在した際に、日本製品の品質の高さやモノづくりへの情熱に感銘を受けました。中でも、独自技術を基にしたビジネスをグローバルに展開しているクレハはとても魅力的でした。特にクレハが世界で初めて工業生産を確立したPGA樹脂「Kuredux®」に関する事業はとてもスケールが大きく、強く惹かれましたね。世の中にまだ無いものをつくる姿勢を常に忘れず、世界中の企業を相手に広い視野で仕事に取り組んでいると感じたところが決め手です。"
    answer03="PGA事業に関する損益管理、北米への製品販売、日本および米国の在庫管理、米国工場の生産管理が主な仕事です。特に損益管理業務では、米国のPGA工場や北米でPGA製品を販売しているグループ会社も含めた連結損益を管理し、予算を策定したりシミュレーションモデルの開発を行ったりもしています。シミュレーションの結果は、事業戦略の策定にも関わってくるため、責任も大きいですがその分やりがいを感じています。"
    answer04="PGA事業部の損益シミュレーションファイルを改善したことです。PGA市場は非常に変化が激しいので、常にアンテナを張り、変化を先読みした素早い対応が必要不可欠。そこで、既存ファイルの課題点を洗い出して解決することで、シミュレーション時間を短縮することができました。様々なケースでのシミュレーションも可能になり、事業戦略策定に寄与できたと思います。"
    answer05="海外でのビジネス展開に適した人財になることです。PGA事業の成長には、北米ビジネスの拡大が欠かせません。実際に北米の事務所に駐在し、しっかりとした事業体制の構築を図り、クレハ製品のグローバル拡販に寄与したいと思っています。そのために、現在は経済やビジネスに関する本を読んで猛勉強中。最終的には、アメリカのグループ会社で財務・経理のCFOになることが目標です！"
    answer06="若手にもチャンスをたくさん与えてくれるところ。どんなことにもチャレンジさせてくれる風土があるので、会社が自分の成長を後押ししてくれていると感じます。「若いから」「外国人だから」といった理由で損をすることはひとつもありません。一人ひとりを貴重な戦力として認識してくれますし、困っているときは声をかけてくれる優しい人ばかりです。周囲を巻き込んで色々なことに挑戦したい方は、ぜひ一緒に仕事をしましょう。楽しみにしています！"
    :imageCut01="require('../../assets/img/gen/staff/02/image01.jpg')"
    :imageCut02="require('../../assets/img/gen/staff/02/image02.jpg')"
    :imageCut01Sp="require('../../assets/img/gen/staff/02/image01_sp.jpg')"
    :imageCut02Sp="require('../../assets/img/gen/staff/02/image02_sp.jpg')"
    :schedule="require('../../assets/img/gen/staff/02/schedule.svg')"
    :scheduleSp="require('../../assets/img/gen/staff/02/schedule_sp.svg')"
    />
  </div>
</template>

<script>
import StaffContents from "@/components/gen/StaffContents.vue";
export default {
  name: 'staff_member',
  components: {
    StaffContents
  },
  methods: {
    startIntersectionObserver: function(targets) {
      this.intersectionObserver = new IntersectionObserver(changes => {
        changes.forEach(change => {
          if(change.isIntersecting) {
            change.target.classList.add('is-show');
          }
        });
      },{
        rootMargin: "0px",
        // threshold: [1.0],
      });
      targets.forEach(target => {
        this.intersectionObserver.observe(target);
      });
    }
  },
  mounted() {
    const targets = Array.from(document.querySelectorAll('.faq'));
    this.startIntersectionObserver(targets);
  }
}
</script>
